import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

/**
 * Resolves the account owner shown in module header labels for staff users.
 * Always mirrors `effectiveOwnerData` so the label matches the owner used for
 * API data (office owner when in office navigation, global owner otherwise).
 */
export default function useModuleDisplayOwner() {
  const { effectiveOwnerData } = useAccountOwnerCommon();
  return effectiveOwnerData;
}

/**
 * @param {{ firstName?: string, lastName?: string, name?: string }|null|undefined} owner
 */
export function getModuleDisplayOwnerName(owner) {
  if (!owner) return "";
  const first = owner.firstName ?? "";
  const last = owner.lastName ?? "";
  const fullName = `${first} ${last}`.trim();
  return fullName || owner.name || "";
}
